module.exports = "/images/chevron_right.svg";